import { Fragment, useState } from "react";
import { DateTime } from "luxon";
import { t } from "i18next";

import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { ButtonPrimary } from "../atoms/ButtonPrimary";
import ColumnText from "../molecules/ColumnText";
import { Empty } from "./Empty";

type CursosProps = {
  id: number | string;
  name: string;
  description: string;
  dias: string;
  hour_init: string;
  duration: string;
  date_init: string;
  date_end: string;
  ocupation: string;
  fees: string;
  days: string;
  timeStart: string;
  dateStart: string;
  dateEnd: string;
  capacity: string;
};

export type TableListCursosUsersProps = {
  cursos: CursosProps[];
  fees: any[];
  onInscribe: () => void;
  onUnsubscribe: () => void;
};

export const TableListCursosUsers: React.FC<TableListCursosUsersProps> = ({
  cursos,
  fees,
  onInscribe,
  onUnsubscribe,
}) => {
  const [filteredCursos, setFilteredCursos] = useState(cursos);

  const onSearch = (value: string) => {
    const filtered = cursos.filter((curso) =>
      curso.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCursos(filtered);
  };

  const getCourseAction = (curso) => {
    /*
    const feesArray = getFeesArray(curso.fees);
    const intersectingFees = getIntersectingFees(feesArray, assignedFees);
    const intersectingNextFees = getIntersectingFees(feesArray, nextFees);
  
    if (
      intersectingFees.length > 0 &&
      !isCourseSubscribed(user, curso.id) &&
      !isCoursePending(user, curso.id) &&
      curso.capacity > curso.ocupation
    ) {
      return (
        <ButtonPrimary
          text={t("course.views.enroll")}
          size="large"
          onClick={() => console.log("Enroll course:", curso.id)}
        />
      );
    }
  
    if (
      intersectingNextFees.length > 0 &&
      intersectingFees.length === 0 &&
      !isCoursePending(user, curso.id)
    ) {
      const nextFee = user.state_fee_course_all_next?.find(
        (fee) => feesArray.includes(fee.fee_id)
      );
      return (
        <button
          className="btn btn-secondary font-weight-bolder"
          onClick={() => console.log("Enroll next course:", curso.id)}
        >
          {t("course.views.enroll")} - {nextFee?.date_init}
        </button>
      );
    }
  
    if (curso.capacity <= curso.ocupation) {
      return <p className="text-danger">{t("course.views.no_slots_available")}</p>;
    }
  
    if (isCourseSubscribed(user, curso.id)) {
      return (
        <button
          className="btn btn-fmw-pink font-weight-bolder"
          onClick={() => console.log("Unsubscribe course:", curso.id)}
        >
          {t("course.views.unsubscribe")}
        </button>
      );
    }
  
    const pendingCourse = getPendingCourse(user, curso.id);
    if (pendingCourse) {
      return (
        <span className="text-warning">
          {t("course.views.pending_enrollment")}{" "}
          {new Date(pendingCourse.registration_date).toLocaleDateString("en-GB")}
        </span>
      );
    }
  
    const subscribedCourse = getSubscribedCourse(user, curso.id);
    if (subscribedCourse) {
      return (
        <span className="text-warning">
          {t("course.views.unsubscribe_date")}{" "}
          {new Date(subscribedCourse.unsubscribe_date).toLocaleDateString("en-GB")}
        </span>
      );
    }
  
    return null;
    */

    return (
      curso.id === 1 ? (
        <>
          <button
            onClick={onUnsubscribe}
            type="button"
            className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          >
            {t("course.views.unsubscribe")}
          </button>
        </>
      ) : (
        <>
          <ButtonPrimary
            text={t("course.views.enroll")}
            size="large"
            onClick={onInscribe}
          />
        </>
      )
    )
  };

  return (
    <div className="mt-5 overflow-visible">
      <div className="px-2 sm:px-3 lg:px-6">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
          <div></div>
          <div className="mt-2 sm:mt-0">
            <InputWithCornerHint
              type="text"
              label=""
              placeholder={t("store.views.form.search_by_name")}
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>
        </div>
        {/* Divider debajo del texto */}
        <div className="flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8 px-4">
            <div className="inline-block min-w-full px-3 py-2 align-middle">
              {cursos.length === 0 ? (
                <Empty texto={t("customer-to-gym-subscription.views.no_courses")} />
              ) : (
                <Fragment>
                  <table className="min-w-full divide-y divide-gray-300 border-t border-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("customer-to-gym-subscription.views.name")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("customer-to-gym-subscription.views.description")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("user.views.days")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("customer-to-gym-subscription.views.time_init")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("assisted.views.duration")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("lesson.views.date_ini")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("lesson.views.date_end")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("lesson.views.ocupation")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("accounting.views.cuotas")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {filteredCursos.map((curso) => (
                        <tr key={curso.id}>
                          <ColumnText title={curso.name} />
                          <ColumnText title={curso.description} />
                          <ColumnText title={curso.days} />
                          <ColumnText title={DateTime.fromFormat(curso.timeStart, "hh:mm:ss").toFormat("hh:mm")} />
                          <ColumnText title={curso.duration} />
                          <ColumnText title={curso.dateStart} />
                          <ColumnText title={curso.dateEnd} />
                          <ColumnText title={`${curso.capacityAva ? curso.capacityAva : ''} / ${curso.capacity}`} />
                          <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                            <ul>
                              {fees
                                .filter((fee) => {
                                  const cursosArray = curso.fees
                                    .split(",")
                                    .map(Number);
                                  return cursosArray.includes(fee.id);
                                })
                                .map((cuotasCurso, index) => (
                                  <li key={index}>{cuotasCurso.name}</li>
                                ))}
                            </ul>
                          </td>
                          <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-sm font-medium sm:pr-0">
                            {getCourseAction(curso)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
